import { AutogenModelMovement, AutogenRowMovement } from "./autogen/AutogenModelMovement";

export class ModelMovement extends AutogenModelMovement<RowMovement> {
    constructor() {
        super(RowMovement);
    }
}

export class RowMovement extends AutogenRowMovement {
}